import * as React from "react";
import VideoProjects from "./VideoProjects";
import { VideoProjectDetailsPage, VideoProjectPage } from "../..";

type Props = {
  tab?: string;
  id?: string;
};

const VideoProjectsTab: React.FC<Props> = ({ id }) => {
  if (id === "new") {
    return <VideoProjectPage embedded />;
  } else if (id !== undefined) {
    return <VideoProjectDetailsPage embedded />;
  } else {
    return <VideoProjects />;
  }
};

export default VideoProjectsTab;
